module.exports = __webpack_public_path__ + "static/media/link.57302289.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/link.svg
// module id = 900
// module chunks = 1